<!-- eslint-disable max-len -->
<template>
  <button @click="toggle">
    <svg enable-background="new 0 0 207.628 207.628" version="1.1" viewBox="0 0 207.63 207.63" xml:space="preserve" xmlns="http://www.w3.org/2000/svg">
      <circle cx="103.81" cy="103.81" r="45.868"/>
      <path d="m103.81 157.18c-29.427 0-53.368-23.941-53.368-53.368s23.941-53.368 53.368-53.368 53.368 23.941 53.368 53.368-23.941 53.368-53.368 53.368zm0-91.737c-21.156 0-38.368 17.212-38.368 38.368s17.212 38.368 38.368 38.368 38.368-17.212 38.368-38.368-17.212-38.368-38.368-38.368z"/>
      <path d="m103.81 39.385c-4.142 0-7.5-3.358-7.5-7.5v-24.385c0-4.142 3.358-7.5 7.5-7.5s7.5 3.358 7.5 7.5v24.385c0 4.142-3.358 7.5-7.5 7.5z"/>
      <path d="m103.81 207.63c-4.142 0-7.5-3.358-7.5-7.5v-24.385c0-4.142 3.358-7.5 7.5-7.5s7.5 3.358 7.5 7.5v24.385c0 4.143-3.358 7.5-7.5 7.5z"/>
      <path d="m200.13 111.31h-24.385c-4.142 0-7.5-3.358-7.5-7.5s3.358-7.5 7.5-7.5h24.385c4.142 0 7.5 3.358 7.5 7.5s-3.357 7.5-7.5 7.5z"/>
      <path d="m31.885 111.31h-24.385c-4.142 0-7.5-3.358-7.5-7.5s3.358-7.5 7.5-7.5h24.385c4.142 0 7.5 3.358 7.5 7.5s-3.358 7.5-7.5 7.5z"/>
      <path d="m154.68 60.452c-1.919 0-3.839-0.732-5.303-2.197-2.929-2.929-2.929-7.678 0-10.606l17.243-17.242c2.929-2.929 7.678-2.93 10.606 0 2.929 2.929 2.929 7.678 0 10.606l-17.243 17.242c-1.464 1.465-3.384 2.197-5.303 2.197z"/>
      <path d="m35.709 179.42c-1.919 0-3.839-0.732-5.303-2.197-2.929-2.929-2.929-7.678 0-10.606l17.243-17.243c2.929-2.929 7.678-2.929 10.606 0 2.929 2.929 2.929 7.678 0 10.606l-17.243 17.243c-1.464 1.465-3.383 2.197-5.303 2.197z"/>
      <path d="m171.92 179.42c-1.919 0-3.839-0.732-5.303-2.197l-17.243-17.243c-2.929-2.929-2.929-7.678 0-10.606 2.929-2.929 7.678-2.929 10.606 0l17.243 17.243c2.929 2.929 2.929 7.678 0 10.606-1.464 1.465-3.383 2.197-5.303 2.197z"/>
      <path d="m52.952 60.452c-1.919 0-3.839-0.732-5.303-2.197l-17.243-17.242c-2.929-2.929-2.929-7.677 0-10.606s7.678-2.93 10.606 0l17.243 17.242c2.929 2.929 2.929 7.677 0 10.606-1.464 1.465-3.383 2.197-5.303 2.197z"/>
    </svg>
  </button>
</template>

<script>
import { mapState, mapMutations } from 'vuex';

export default {
  computed: {
    ...mapState(['theme']),
  },
  methods: {
    ...mapMutations(['setTheme']),
    toggle() {
      this.setTheme(this.theme === 'light' ? 'dark' : 'light');
    },
  },
};
</script>

<style lang="scss" scoped>
button {
  display: flex;
  align-items: center;
}

svg {
  height: 24px;
  fill: var(--text-primary);
}
</style>
